import { Card, Row, Col, Badge } from "reactstrap";
import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { HARBOR_ACTIONS_TEMP_DISABLED } from "../../../config/harborUiFlags";

const MyVesselsScreen = ({
  user,
  myBalance,
  vessels,
  goToVesselDetails,
  goToTopup,
  setCurrentScreen,
  isMyVessel,
  setResubmitVessel,
  handleDeleteVessel,
}) => {
  const [confirmDeleteVessel, setConfirmDeleteVessel] = useState(null);

  return (
    <React.Fragment>
      <button
        className="btn btn-primary fs-6 py-1"
        onClick={() => setCurrentScreen("initial")}
      >
        <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span>
        <span className="">Back</span>
      </button>
      <Card className="p-3 mt-4 mb-3">
        <Row>
          <Col className="col-8 col-sm-8 col-md-10 col-lg-10">
            <div className="text-left">
              <h1 className="">{!isMyVessel ? vessels?.[0]?.owner?.name + "'s Vessels" : user.name}</h1>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="col-4 col-sm-4 col-md-2 col-lg-2">
            <div className="text-left">
              <span className="font-weight-semibold">Email Address:</span>
            </div>
          </Col>
          <Col className="col-8 col-sm-8 col-md-10 col-lg-10">
            <div className="text-left">
              <span className="">{!isMyVessel ? vessels?.[0]?.owner?.email : user.email}</span>
            </div>
          </Col>
        </Row>
        {isMyVessel && 
          <Row>
            <Col className="col-4 col-sm-4 col-md-2 col-lg-2">
              <div className="text-left">
                <span className="font-weight-semibold">Contact No:</span>
              </div>
            </Col>
            <Col className="col-8 col-sm-8 col-md-10 col-lg-10">
              <div className="text-left">
                <span className="">{!isMyVessel ? vessels?.[0]?.owner?.mobile_number : user.mobile_number}</span>
              </div>
            </Col>
          </Row>
        }
        <Row>
          <Col className="col-md-5 col-lg-5 col-xl-4">
            {isMyVessel ? (
              <Card outline color="primary" className="mt-3 mb-0 border">
                <Row className="" style={{ paddingRight: "12px" }}>
                  <Col className="col-8 my-2" style={{ paddingLeft: "25px" }}>
                    <Col>
                      <span className=" text-muted fs-6">Credit Balance</span>
                    </Col>
                    <Col className="">
                      <span className=" font-weight-semibold text-muted fs-4">
                        MVR
                      </span>
                      &nbsp;&nbsp;
                      <span className="font-weight-semibold fs-4 text-primary">
                        {myBalance}
                      </span>
                    </Col>
                  </Col>
                  <Col
                    className={`col-4 text-light ${HARBOR_ACTIONS_TEMP_DISABLED ? "bg-secondary" : "bg-primary"}`}
                    style={{
                      borderRadius: "0px 4px 4px 0px",
                      cursor: HARBOR_ACTIONS_TEMP_DISABLED ? "not-allowed" : "pointer",
                      opacity: HARBOR_ACTIONS_TEMP_DISABLED ? 0.85 : 1,
                    }}
                    title={
                      HARBOR_ACTIONS_TEMP_DISABLED
                        ? "Top-Up is temporarily unavailable"
                        : undefined
                    }
                  >
                    <div
                      className="text-center"
                      onClick={() => {
                        if (!HARBOR_ACTIONS_TEMP_DISABLED) goToTopup();
                      }}
                    >
                      <Col
                        className="text-center"
                        style={{ paddingTop: "5px" }}
                      >
                        <span className="font-weight-semibold">Top-Up</span>
                      </Col>
                      <Col>
                        <span
                          className="mdi mdi-plus"
                          style={{ fontSize: "25px" }}
                        />
                      </Col>
                    </div>
                  </Col>
                </Row>
              </Card>
            ) : null}
          </Col>
        </Row>
      </Card>

      <Card className="p-3">
        {isMyVessel &&
          <Col>
            <div className="mt-2 mb-3">
              <Row>
                <Col className="col-md-4 col-lg-4 col-xl-3">
                  <SimpleButton
                    color={"primary"}
                    icon={"mdi mdi-chevron-right"}
                    text={"Add New Vessel"}
                    clickFn={() => setCurrentScreen("addNewVessel")}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        }
        {vessels?.filter((a) => a.active).length > 0 ? (
          <Card outline color="light" className=" p-3 border">
            <h4 className="font-weight-semibold text-success">
              Active Vessels
            </h4>
            <Row>
              {vessels
                ?.filter((a) => a.active)
                .map((vessel, index) => {
                  return (
                    <Col
                      className="col-12 col-md-6 col-lg-5 col-xl-4"
                      key={index}
                    >
                      <div
                        key={index}
                        onClick={() => goToVesselDetails({ vessel: vessel })}
                      >
                        <Card
                          color="success"
                          outline
                          className="mt-1 p-3 mb-3 border-2"
                          style={{ cursor: "pointer" }}
                        >
                          <Row>
                            <Col className="col-9">
                              <Col>
                                <span className="font-weight-semibold fs-5">
                                  {vessel.name}
                                </span>
                              </Col>
                              <Col>
                                <span>{vessel.registration_number}</span>
                              </Col>
                              <Col>
                                <span>{vessel.vessel_type.name}</span>
                              </Col>
                            </Col>
                            <Col
                              className="col-3 align-middle"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <span
                                  className="mdi mdi-chevron-right align-middle text-success"
                                  style={{ fontSize: "40px" }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </Card>
        ) : null}

        {isMyVessel && vessels?.filter((a) => !a.active).length > 0 ? (
          <Card outline color="kight" className=" p-3 border">
            <h4 className="font-weight-semibold text-warning">
              Inactive Vessels
            </h4>
            <Row>
              {vessels
                ?.filter((a) => !a.active)
                .map((vessel, index) => {
                  return (
                    <Col
                      className="col-12 col-md-6 col-lg-5 col-xl-4"
                      key={index}
                    >
                      <div
                        key={index}
                        onClick={() => goToVesselDetails({ vessel: vessel })}
                      >
                        <Card
                          outline
                          color="warning"
                          className="mt-1 p-3 mb-3 border-2"
                          style={{ cursor: "pointer" }}
                        >
                          <Row>
                            <Col className="col-9">
                              <Col>
                                <span className="font-weight-semibold fs-5">
                                  {vessel.name}
                                </span>
                              </Col>
                              <Col>
                                <span>{vessel.registration_number}</span>
                              </Col>
                              <Col>
                                <span>{vessel.vessel_type.name}</span>
                              </Col>
                              <Col>
                                <Badge
                                  className={`bg-${
                                    vessel.status === "PENDING"
                                      ? "warning"
                                      : vessel.status === "REJECTED"
                                      ? "danger"
                                      : "success"
                                  }`}
                                >
                                  <span className="px-2 fs-6">
                                    {vessel.status}
                                  </span>
                                </Badge>
                              </Col>
                              {vessel.status === "REJECTED" && (
                                <Col className="mt-2">
                                  <button
                                    className="btn btn-sm btn-warning me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setResubmitVessel(vessel);
                                      setCurrentScreen("resubmitVessel");
                                    }}
                                  >
                                    Edit &amp; Resubmit
                                  </button>
                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setConfirmDeleteVessel(vessel);
                                    }}
                                  >
                                    Delete
                                  </button>
                                </Col>
                              )}
                            </Col>
                            <Col
                              className="col-3 align-middle"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <span
                                  className="mdi mdi-chevron-right align-middle text-warning"
                                  style={{ fontSize: "40px" }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </Card>
        ) : null}
      </Card>

      {confirmDeleteVessel && (
        <SweetAlert
          warning
          showCancel
          confirmBtnText="Yes, delete"
          cancelBtnText="Cancel"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="secondary"
          title="Are you sure?"
          onConfirm={() => {
            handleDeleteVessel(confirmDeleteVessel);
            setConfirmDeleteVessel(null);
          }}
          onCancel={() => setConfirmDeleteVessel(null)}
        >
          You are about to delete {confirmDeleteVessel.name}. This action cannot be undone.
        </SweetAlert>
      )}
    </React.Fragment>
  );
};
export default MyVesselsScreen;

const SimpleButton = ({ color, icon, text, clickFn }) => {
  return (
    <div onClick={() => clickFn(true)}>
      <Card
        className={`px-3 py-2 mb-0 bg-${color} text-white`}
        style={{ cursor: "pointer" }}
      >
        <Row>
          <Col
            className="col-10 align-middle"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <span className="fs-6">{text}</span>
          </Col>
          <Col
            className="col-2 align-middle"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <span
                className={`${icon} align-middle text-white`}
                style={{ fontSize: "20px" }}
              />
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};
